export default "/_next/static/images/4ccf434857ef6520c2cf9c2d4701de49.jpg";